const toggleContent = (element, isCollapsed, innerHTML, contentTruncated, showMoreText, showLessText) => {
  const actionText = isCollapsed ? showLessText : showMoreText;
  element.innerHTML = isCollapsed ? innerHTML : contentTruncated;
  element.innerHTML += ` <a href="#" class="pf-read-more">${actionText}</a>`;
  element.setAttribute("data-collapse", String(!isCollapsed));
};

function truncateContentByWords(elementInnerHTML, maxWords) {
  const words = elementInnerHTML.split(/\s+/);
  if (words.length > maxWords) {
    return words.slice(0, maxWords).join(' ') + '...';
  } else {
    return elementInnerHTML;
  }
}

const truncateFunctionality = element => {
  const elementTruncateContentLength = element.getAttribute("data-truncate-content-length");
  const showMoreText = element.getAttribute("data-more")?.trim() || "Show more";
  const showLessText = element.getAttribute("data-less")?.trim() || "Show less";
  let elementInnerHTML = element.innerHTML.replace(/<meta charset="utf-8"[^>]*>|(<style>((.|\s)*?)<\/style>)|(<script((.|\s)*?)<\/script>)/g, "");

  if (elementTruncateContentLength) {
    let contentTruncated = truncateContentByWords(elementInnerHTML, parseInt(elementTruncateContentLength));
    element.innerHTML = contentTruncated;
    if (contentTruncated.length < elementInnerHTML.length) {
      element.innerHTML += ` <a href="#" class="pf-read-more">${showMoreText}</a>`;
      element.setAttribute("data-collapse", String(true));
    }

    element.onmousedown = function(e) {
      const target = e.target.closest(".pf-read-more");
      if (target) {
        e.preventDefault();
        const isCollapsed = element.getAttribute("data-collapse") === "true";
        toggleContent(element, isCollapsed, elementInnerHTML, contentTruncated, showMoreText, showLessText);
      }
    };
  } else {
    element.innerHTML = elementInnerHTML;
  }
};

document.querySelectorAll('[data-truncate-content="true"]').forEach(truncateFunctionality);
